module.exports = "https://static.wmbcdn.com/uniweb/images/a852f3b485f8cab4066600f30555ce0e.svg";